<template>
  <div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Approve Product Pricing?</p>
      </header>
      <section class="modal-card-body">
        <p class="py-xl has-text-centered">
          Are you sure you want to approve pricing for this product?
        </p>
      </section>
      <footer class="modal-card-foot space-between" >
        <b-button @click="$parent.close()">Close</b-button>
        <b-button
          type="is-primary"
          :disabled="saving"
          :loading="saving"
          @click="save">Approve Pricing</b-button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['auth', 'context']),
    endpoint () {
      return this.context.route + '/proposals/' + this.proposal.id + '/'
    }
  },
  data () {
    return {
      saving: false,
      errors: {}
    }
  },
  methods: {
    async save () {
      this.saving = true
      await this.approvePricing()
      await this.completeProposal()
      this.$buefy.toast.open({ type: 'is-success', message: 'Proposal approved!' })
      this.$emit('proposal:priced')
      this.saving = false
      this.$parent.close()
    },
    approvePricing () {
      return this.$http.patch(this.endpoint, { status: 'pricing_approved', sign_off: this.auth.user.fullName })
    },
    completeProposal () {
      return this.$http.patch(this.endpoint, { status: 'completed' })
    }
  },
  props: {
    proposal: {
      type: Object,
      required: true
    }
  }
}
</script>
